const BK_LIKE_ROLES = ["BK", "MN"];

const BK_FEATURES = [
  "marketingdataanalysis",
  "products",
  "warehouses",
  "employeemanagement",
  "Orders",
  "transactions",
  "invoices",
  "manufacturer",
  "venues",
  "deviceinfos",
  "agentmanagements",
  "membershipmanagement",
  "couponmanagement",
  "keymetrics",
  "membershipanalysis",
  "reset-password",
  "sign-out",
];

const MN_FEATURES = [
  "marketingdataanalysis",
  "products",
  "warehouses",
  "employeemanagement",
  "Orders",
  "transactions",
  "invoices",
  "manufacturer",
  "venues",
  "deviceinfos",
  "agentmanagements",
  "membershipmanagement",
  "couponmanagement",
  "keymetrics",
  "membershipanalysis",
  "reset-password",
  "sign-out",
];

const CM_FEATURES = [
  "warehouses",
  "transactions",
  "invoices",
  "deviceinfos",
  "reset-password",
  "sign-out",
];

const SP_FEATURES = [
  "tables",
  "Exposures",
  "transactions",
  "deviceinfos",
  "Credits",
  "agentmanagements",
  "reset-password",
  "sign-out",
];

const ROLE_FEATURES = {
  BK: BK_FEATURES,
  MN: MN_FEATURES,
  CM: CM_FEATURES,
  SP: SP_FEATURES,
};

const ALL_ROLES = Object.keys(ROLE_FEATURES);

export const getRolesForFeature = (featureKey) => {
  const allowed = ALL_ROLES.filter((role) => ROLE_FEATURES[role]?.includes(featureKey));
  return allowed.length > 0 ? allowed : null;
};

export const isBkLikeRole = (role) => BK_LIKE_ROLES.includes(role);
